/**
 * Block: services-general
 * V2 JS — Mobile Slick slider for service cards
 */

export function init() {
  const block = document.querySelector('.services-general');
  if (!block) return;

  const $slider = block.querySelector('.services-general__slider');
  if (!$slider) return;

  if (typeof jQuery === 'undefined' || typeof jQuery.fn.slick === 'undefined') return;

  const $ = jQuery;

  $($slider).slick({
    slidesToShow: 1.22,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    infinite: false,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 778,
        settings: 'unslick',
      },
    ],
  });
}
